import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";

const NO_REDIRECT = "gac_nc";

// Android WebView in-app (WhatsApp/FB/IG) — Chrome asli & Custom Tab tidak ditandai "wv".
const isAndroidInApp = () => {
  const ua = navigator.userAgent || "";
  return /Android/i.test(ua) && (/; wv\)/.test(ua) || /WhatsApp|FBAN|FBAV|Instagram/i.test(ua));
};

const buildIntent = () => {
  const { host, pathname, search, hash } = window.location;
  const params = new URLSearchParams(search);
  params.set(NO_REDIRECT, "1");   // cadangan tanpa Chrome → tidak redirect berulang
  const fallback = `https://${host}${pathname}?${params}${hash}`;
  return `intent://${host}${pathname}${search}#Intent;scheme=https;package=com.android.chrome;`
    + `S.browser_fallback_url=${encodeURIComponent(fallback)};end`;
};

// Halaman tracking dibuka dari tombol WA (browser in-app) → lempar ke Chrome.
export const OpenInChrome = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!isAndroidInApp() || new URLSearchParams(window.location.search).has(NO_REDIRECT)) return undefined;
    window.location.href = buildIntent();
    const t = setTimeout(() => setShow(true), 1500);   // lemparan diblokir → tampilkan tombol manual
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;
  return (
    <a href={buildIntent()} data-testid="open-in-chrome-btn"
      className="flex items-center justify-center gap-2 mx-4 mt-3 h-11 rounded-xl bg-[#E65100] text-white text-sm font-bold shadow-md active:scale-[0.98] transition-transform">
      <ExternalLink className="w-4 h-4" /> Buka di Chrome agar tracking lebih lancar
    </a>
  );
};
